import gql from 'graphql-tag';

export const OTHER_TECHNOLOGY_PROPAGATE = gql`
    mutation($input:OtherTechnologyBenchlingPropagateMutationInput!){
        otherTechnologyBenchlingPropagate(input:$input){
            benchlingId
        }
    }
`;